export const Data = [
    {
        id: 1,
        question: "Rolex is a company that specializes in what type of product?",
        answers: [
            { text: "Phone", correct: false },
            { text: "Watches", correct: true },
            { text: "Food", correct: false },
            { text: "Cosmetic", correct: false },
        ],
    },
    {
        id: 2,
        question: "When did the website 'Facebook' launch?",
        answers: [
            { text: "2004", correct: true },
            { text: "2005", correct: false },
            { text: "2006", correct: false },
            { text: "2007", correct: false },
        ],
    },
    {
        id: 3,
        question: "Who played the character of Harry Potter in the movie?",
        answers: [
            { text: "Johnny Depp", correct: false },
            { text: "Leonardo DiCaprio", correct: false },
            { text: "Denzel Washington", correct: false },
            { text: "Daniel Radcliffe", correct: true },
        ],
    },
    {
        id: 4,
        question: "Which country is known as the Land of the Rising Sun?",
        answers: [
            { text: "Japan", correct: true },
            { text: "China", correct: false },
            { text: "South Korea", correct: false },
            { text: "Thailand", correct: false },
        ],
    },
    {
        id: 5,
        question: "What is the chemical symbol for water?",
        answers: [
            { text: "O", correct: false },
            { text: "H2", correct: false },
            { text: "CO2", correct: false },
            { text: "H2O", correct: true },
        ],
    },
    {
        id: 6,
        question: "Which planet is closest to the Sun?",
        answers: [
            { text: "Mars", correct: false },
            { text: "Venus", correct: false },
            { text: "Mercury", correct: true },
            { text: "Jupiter", correct: false },
        ],
    },
    {
        id: 7,
        question: "What is the currency of Brazil?",
        answers: [
            { text: "Dollar", correct: false },
            { text: "Euro", correct: false },
            { text: "Real", correct: true },
            { text: "Pound", correct: false },
        ],
    },
    {
        id: 8,
        question: "Which famous scientist formulated the theory of relativity?",
        answers: [
            { text: "Isaac Newton", correct: false },
            { text: "Albert Einstein", correct: true },
            { text: "Galileo Galilei", correct: false },
            { text: "Marie Curie", correct: false },
        ],
    },
    {
        id: 9,
        question: "What is the largest mammal on Earth?",
        answers: [
            { text: "Elephant", correct: false },
            { text: "Blue Whale", correct: true },
            { text: "Giraffe", correct: false },
            { text: "Gorilla", correct: false },
        ],
    },
    {
        id: 10,
        question: "Who wrote the play 'Hamlet'?",
        answers: [
            { text: "Oscar Wilde", correct: false },
            { text: "William Shakespeare", correct: true },
            { text: "Jane Austen", correct: false },
            { text: "Charles Dickens", correct: false },
        ],
    },
    {
        id: 11,
        question: "What is the largest organ in the human body?",
        answers: [
            { text: "Liver", correct: false },
            { text: "Brain", correct: false },
            { text: "Skin", correct: true },
            { text: "Heart", correct: false },
        ],
    },
    {
        id: 12,
        question: "Which city is known as the 'Big Apple'?",
        answers: [
            { text: "Chicago", correct: false },
            { text: "Los Angeles", correct: false },
            { text: "New York City", correct: true },
            { text: "Dallas", correct: false },
        ],
    },
    {
        id: 13,
        question: "What is the chemical symbol for gold?",
        answers: [
            { text: "Au", correct: true },
            { text: "Ag", correct: false },
            { text: "Fe", correct: false },
            { text: "Pt", correct: false },
        ],
    },
    {
        id: 14,
        question: "Which continent is the largest by land area?",
        answers: [
            { text: "Asia", correct: true },
            { text: "North America", correct: false },
            { text: "Africa", correct: false },
            { text: "South America", correct: false },
        ],
    },
    {
        id: 15,
        question: "Who wrote the novel 'To Kill a Mockingbird'?",
        answers: [
            { text: "George Orwell", correct: false },
            { text: "J.K. Rowling", correct: false },
            { text: "Harper Lee", correct: true },
            { text: "Stephen King", correct: false },
        ],
    },
];
